// prop.heading is the heading for the HourSummary.
// props.hours is the hours being shown
// props.onClick is what to call when clicked.

// Format a counter reading with thousands separators while preserving any
// decimal portion the user entered. Non-numeric values pass through
// unchanged so we don't accidentally swallow placeholders like "—".
function formatHours(hours) {
  if (hours === null || hours === undefined || hours === '') return hours;
  const n = Number(hours);
  if (!Number.isFinite(n)) return hours;
  return n.toLocaleString(undefined, { maximumFractionDigits: 20 });
}

function HourSummary(props) {
  return (
    <div className="col-xl-3 col-sm-6 col-12 mb-4" onClick={props.onClick}>
      <div className="card">
        <div className="card-body">
          <div className="d-flex justify-content-between px-md-1">
            <div className="align-self-center">
              <i className="fas fa-3x fa-clock text-primary"></i>
            </div>
            <div className="text-end">
              <h5>{props.heading}</h5>
                <div className="d-flex justify-content-center align-items-center">
                  <div className="px-1 entered-data">{formatHours(props.hours)}</div>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <div className="text-muted">Click to edit.</div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HourSummary;
